module.exports = __webpack_public_path__ + "img/step3-c.e4cefba9.png";